<template>
  <tux-mdes-verification-options
    :show-cancel-button="true"
    :issuer-name="issuerName"
    :options="options"
    :selected-credential-reference="selectedCredential"
    @submit="onContinue"
    @cancel="onCancel" />
</template>

<script>
import { AuthenticationStrategy } from '@mc-alberta/stark'
import { TuxMdesVerificationOptions } from '@mc-alberta/tuxedo'
import { defineComponent, getCurrentInstance, onMounted } from '@vue/composition-api'
import { LOADERS, ROUTES } from '@/constants'
import { getStark, sessionRouteGuard } from '@/store/modules/authentication'

export default defineComponent({
  name: ROUTES.VERIFY_OPTIONS,
  components: {
    TuxMdesVerificationOptions
  },
  beforeRouteEnter(to, from, next) {
    return sessionRouteGuard(AuthenticationStrategy.MDES, next)
  },
  setup() {
    onMounted(() => store.dispatch('stopAllLoaders'))

    const { proxy } = getCurrentInstance()
    const store = proxy.$store
    const issuerName = store.getters.issuerName
    const stark = getStark()

    const options = stark.authenticationMethods
    const selectedCredential = stark.authenticationMethod?.authenticationCredentialReference

    /**
     * Authentication method selection handler.
     */
    function onContinue(selectedMethod) {
      stark.selectAuthenticationMethod(selectedMethod)

      store.dispatch('startLoader', LOADERS.VERIFY_DETAILS)
      store.dispatch('handleAuthSession', stark.initializeSession())
    }

    /**
     * Shows the authentication session cancellation modal.
     */
    function onCancel() {
      this.$root.$emit('alcapone-toggle:al-modal', 'cancel-challenge-modal')
    }

    return {
      issuerName,
      selectedCredential,
      options,
      onContinue,
      onCancel
    }
  }
})
</script>
